import API from '../../../../common/http/api.fetch';
import { formatDate } from '../../../../common/utils/util.date';
import * as TYPE from '../pnp-docs.actions.types';
import { responseMessage } from '../../../../common/utils/util.notifier';
export const getDocument = (filter) => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/docs`,
            method: 'GET',
            params: {
                location: filter.location,
                offset: filter.offset,
                limit: filter.limit,
                keyword: filter.keyword,
                documentStatus: filter.documentStatus,
                documentCategory: filter.documentCategory,
                linkWithAccreditation: filter.linkWithAccreditation,
                documentType: filter.documentType,
                createdDateFrom: filter.createdDateFrom ? formatDate(filter.createdDateFrom): null,
                createdDateTo: filter.createdDateTo? formatDate(filter.createdDateTo): null,
                exportFormat: filter.exportFormat,
                exportColumns: filter.exportColumns
            }
        }).then(({ data }) => {
            if (filter.exportFormat) {
                return data;
            }
            dispatch({
                type: 'GRID_FETCH',
                id: 'pnpDocumentGrid',
                items: data.items.map((item) => {
                    return {
                        id: item.id,
                        title: item.title,
                        version: item.version,
                        docNum: item.doc_num,
                        documentApplicationType: item.document_application_type,
                        documentType: item.document_type,
                        documentCategory: item.document_category,
                        approvalDueDate: item.task_due_date,
                        documentDueDate: item.due_date,
                        path: item.path,
                        pdfPath: item.pdf_uri,
                        docStatus: item.doc_status,
                        author: item.author,
                        created_date: item.created_date,
                        linkWithAccreditation: item.is_link_with_accreditation,
                        headOffice: item.head_office_name,
                        siteLocation: item.site_location_name,
                        department: item.department_name,
                    }
                }),
                itemsCount: parseInt(data.items_count)
            })
        });
    }
}

export const getDocumentHistory = (id) => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc/history`,
            method: 'GET',
            params: {
                id: typeof id === 'number' ? id : id.id ,
                exportFormat: id.exportFormat,
                exportColumns: id.exportColumns,
            }
        }).then(({ data }) => {
            if (id.exportFormat) {
                return data;
            }
            dispatch({
                type: 'GRID_FETCH',
                id: 'pnpDocumentHistoryGrid',
                items: data.map((item) => {
                    return {
                        id: item.id,
                        vdoId: item.vdo_id,
                        title: item.title,
                        version: item.version,
                        docNum: item.doc_num,
                        documentApplicationType: item.document_application_type,
                        documentType: item.document_type,
                        documentCategory: item.document_category,
                        dueDate: item.due_date,
                        path: item.path,
                        docStatus: item.doc_status,
                        author: item.author,
                        created_date: item.created_date,
                        downloadAllowed: item.download_allowed
                    }
                }),
                itemsCount: parseInt(data.length)
            })
        });
    }
}

export const saveDocument = (data) => {
    const documentRiskLevel = data.documentRiskLevels.find((documentRiskLevel) => documentRiskLevel.value === data.documentRiskLevel);
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc/save`,
            method: 'POST',
            data: {
                id: data.id,
                title: data.title,
                documentCategory: data.documentCategory,
                documentType: data.documentType,
                documentApplicationType: data.documentApplicationType,
                documentRiskLevel,
                version: data.version,
                docNum: data.docNum,
                path: data.path,
                location: data.location,
                reviewers: data.selectedReviewers,
                approvers: data.selectedApprovers,
                comment: data.comment
            }
        }).then((response) => {
            dispatch({
                type: 'GRID_RELOAD',
                id: 'pnpDocumentGrid'
            })
            dispatch({
                type: 'GRID_RELOAD',
                id: 'pnpDocumentEventActionsGrid'
            })
            if (!data.id) {
                dispatch({
                    type: 'PNP_DOCUMENT_RESET',
                    id: 'pnpDocument'
                });
            }
        });
    }
}

export const getDocumentDetails = (id, updateVersion=false) => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc/details`,
            method: 'GET',
            params: { id }
        }).then(({ data }) => {
            dispatch({
                type: TYPE.PNP_DOCUMENT_DETAILS,
                id: 'pnpDocument',
                data: data[0][0],
                locations: data[1],
                updateVersion
            })
        });
    }
};

export const getDocumentHistoryDetails = (id) => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc/history/details`,
            method: 'GET',
            params: { id }
        }).then(({ data }) => {
            dispatch({
                type: TYPE.PNP_DOCUMENT_DETAILS,
                id: 'pnpDocument',
                data: data[0],
            })
        });
    }
};

export const getDocumentReviewerApproverDetails = (id) => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc-reviewer-approver/details`,
            method: 'GET',
            params: { id }
        }).then(({ data }) => {
            const reviewers = data.filter((type) => type.type_name === 'Document Review Task')
            const approvers = data.filter((type) => type.type_name === 'Document Approval Task')
            dispatch({
                type: TYPE.PNP_DOCUMENT_REVIEWER_APPROVER_DETAILS,
                id: 'pnpDocument',
                data: { reviewers, approvers },
            })
        });
    }
};

export const deleteDocument = (id) => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc/archive`,
            method: 'GET',
            params: { id }
        }).then(() => {
            dispatch({
                type: 'GRID_RELOAD',
                id: 'pnpDocumentGrid'
            })
        });
    }
};

export const getAccreditationDocument = (filter) => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc/accreditation`,
            method: 'GET',
            params: {
                offset: 0,
                limit: 100,
                id:filter.id,
                documentAccreditationSchemes: filter.documentCategory,
                exportFormat: filter.exportFormat,
                exportColumns: filter.exportColumns,
            },
        }).then(({ data }) => {
            if (filter.exportFormat) {
                return data;
            }
            dispatch({
                type: 'GRID_FETCH',
                id: 'pnpDocumentAccreditationGrid',
                ...data,
                items: data.items.map((item) => ({
                    id: item.id,
                    documentAccreditationSchemes: item.accreditation_name,
                    documentAccreditationSection: item.accreditation_section_name,
                    documentAccreditationSchemesId: item.astid
                }))
            });
        }, error => {
            responseMessage(error);
            dispatch({
                type: 'GRID_FETCH',
                id: 'pnpDocumentAccreditationGrid',
                items: [],
            })
        });
    };
};

export const saveAccreditationDocument = (data) => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc/accreditation/save`,
            method: 'POST',
            data: data
        }).then((response) => {
            dispatch({
                type: 'GRID_RELOAD',
                id: 'pnpDocumentAccreditationGrid'
            })
            if (!data.id) {
                dispatch({
                    type: 'PNP_DOCUMENT_RESET',
                    id: 'pnpDocument'
                });
            }
        });
    }
}

export const deleteAccreditationDocument = (id) => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc/accreditation/delete`,
            method: 'GET',
            params: { id }
        }).then(() => {
            dispatch({
                type: 'GRID_RELOAD',
                id: 'pnpDocumentAccreditationGrid'
            })
        });
    }
};

export const fetchEvidenceGroupRequirementsGrid = (filter) => {
    return dispatch => {
        return API.fetch({
            url:    '/rco/list-evidence-group-requirements-grid',
            method: 'GET',
            params: {
                ard_id: filter.ard_id
            },
        }).then(({data}) => {
            dispatch({
                type:   'GRID_FETCH',
                id:     'pnpDocSectionsGrid',
                path:   filter.path,
                items:  data.items.map((item) => ({
                    id: item.id,
                    documentAccreditationScheme: item.documentAccreditationSchemes,
                    documentAccreditationSection: item.documentAccreditationSection,
                })),
            });
        }, error => {
            responseMessage(error);
        })
    }
}

export const getDocumentEventActions = (filter) => {
    return (dispatch, getState) => {
        const state = getState();
        return API.fetch({
            url: `/pnp/doc/event-actions`,
            method: 'GET',
            params: {
                offset: 0,
                limit: 100,
                vdo_id: state.policies.pnpDocument.id,
                exportFormat: filter.exportFormat,
                exportColumns: filter.exportColumns,
            },
        }).then(({ data }) => {
            if (filter.exportFormat) {
                return data;
            }
            dispatch({
                type: 'GRID_FETCH',
                id: 'pnpDocumentEventActionsGrid',
                items: data.items.map((item) => ({
                    id: item.alo_id,
                    actionName: item.action_name,
                    actionCode: item.action_code,
                    issuerName: item.issuer_full_name,
                    issuerUsername: item.issuer_username,
                    actionDate: formatDate(item.action_time),
                    actionDescription: item.action_description,
                    documentId: item.document_id,
                    documentName: item.doc_name,
                    documentNumber: item.doc_num,
                    comment: item.pnp_comment
                })),
                itemsCount: parseInt(data.items_count, 10),
            });
        }, error => {
            responseMessage(error);
            dispatch({
                type: 'GRID_FETCH',
                id: 'pnpDocumentEventActionsGrid',
                items: [],
            })
        });
    };
};


